import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
import { getAnalytics, Analytics, logEvent as firebaseLogEvent, isSupported } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'lp-form-biomo',
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
}

let app: FirebaseApp | null = null
let auth: Auth | null = null
let analytics: Analytics | null = null

function initializeFirebase() {
  if (typeof window === 'undefined') return

  if (!firebaseConfig.apiKey) {
    console.warn('Firebase API key not configured')
    return
  }

  if (!app) {
    app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp()
    auth = getAuth(app)

    // Inicializa Firebase Analytics (verifica suporte do browser)
    if (firebaseConfig.measurementId) {
      isSupported().then((supported) => {
        if (supported && app) {
          analytics = getAnalytics(app)
        }
      })
    }
  }
}

if (typeof window !== 'undefined') {
  initializeFirebase()
}

export function getFirebaseAuth(): Auth {
  initializeFirebase()
  if (!auth) throw new Error('Firebase Auth not initialized')
  return auth
}

export function getFirebaseAnalytics(): Analytics | null {
  return analytics
}

/**
 * Envia evento para Firebase Analytics
 */
export function logEvent(eventName: string, params?: Record<string, unknown>) {
  if (analytics) {
    firebaseLogEvent(analytics, eventName, params)
  }
}

export function getFirebaseApp(): FirebaseApp | null {
  initializeFirebase()
  return app
}

export { auth, analytics }
export default app
